module.exports = __webpack_public_path__ + "img/product-placeholder-10.23b743e.png";